import { Component, Input, OnInit } from '@angular/core';
import { PageTitleService } from '../../_services/page-title.service';

@Component({
  selector: 'app-standard-page',
  templateUrl: './standard-page.component.html',
  styleUrls: ['./standard-page.component.scss']
})
export class StandardPageComponent implements OnInit {
  @Input() pageTitle: string = '';
  @Input() pageSubtitle: string = '';
  @Input() breadcrumbs: Array<{ label: string; url?: string }> = [];
  @Input() showHeader: boolean = true;
  @Input() showFooter: boolean = true;

  constructor(private pageTitleService: PageTitleService) {}

  ngOnInit(): void {
    if (this.pageTitle) {
      this.pageTitleService.setPageInfo({
        title: this.pageTitle,
        subtitle: this.pageSubtitle,
        breadcrumbs: this.breadcrumbs
      });
    }
  }
}
